export default {
  SAVE_ID(state, id) {
    state.id = id
  },
  SAVE_STATUS(state, status) {
    state.status = status
  },
}
